export const environment = {
	production: true,
	envName: 'prod-india',
	cognitoConfig: {
		mandatorySignIn: true,
		region: 'ap-south-1',
		userPoolId: 'ap-south-1_tTZw5Y6ha',
		userPoolWebClientId: '5dqrg18idho88jahjn7sfi5678',
		oauth: {
			domain: 'ap-south-1ttzw5y6ha.auth.ap-south-1.amazoncognito.com',
			scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
			redirectSignIn: 'https://osm.india.myosmtech.com/home',
			redirectSignOut: 'https://osm.india.myosmtech.com/home',
			responseType: 'code'
		}
	},
	baseUrl: 'https://75lsn8mh19.execute-api.ap-south-1.amazonaws.com/osm-prodapsouth1-blue-apistage'
};
